import {
    POINT_DELETING, POINT_DOWNLOADED, POINT_FAILED, POINT_FOCUS,
    POINT_RESET, POINTS_DOWNLOADED, POINTS_FAILED, POINTS_PENDING,
    POINTS_RESET, POINT_DELETED, POINT_EDITING, POINT_POSTING,
    POINT_MEDIA_UPLOADING, POINT_MEDIA_UPLOADED, POINT_MEDIA_FAILED,
    POINT_MEDIA_DELETING, POINT_MEDIA_DELETED, POINT_MEDIA_FOCUS
} from "./types";
import LangService from '../../services/lang';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    deletingMedia: false,
    pending: false,
    sending: false,
    currentIndex: null,
    currentPoint: null,
    currentMedia: null,
    pendingMedias: [],
    uploadedMedias: [],
    failedMedias: []
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case POINTS_RESET:
            return INITIAL_STATE;
        case POINT_RESET:
            return {
                ...state,
                error: null,
                sending: false,
                currentIndex: 0,
                currentPoint: null
            };
        case POINT_POSTING:
            return {
                ...state,
                sending: true
            };
        case POINT_EDITING:
            return {
                ...state,
                sending: true
            };
        case POINT_DELETING:
            return {
                ...state,
                sending: true
            };
        case POINT_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            LangService.langs.forEach(function (l) {
                if (newState.content[l.key] !== undefined) {
                    newState.content[l.key] = state.content[l.key].filter((point) => {
                        return point.id !== action.payload.id;
                    });
                }
            });

            if (state.currentPoint) {
                if (state.currentPoint.id === action.payload.id) {
                    newState.currentPoint = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content[action.payload.lang].findIndex((point) => {
                        return newState.currentPoint.id === point.id
                    });
                }
            }

            return newState;
        case POINTS_PENDING:
            return {
                ...state,
                pending: true
            };
        case POINTS_DOWNLOADED:
            let newContentPoint = {...state.content};
            newContentPoint[action.payload.lang] = action.payload.points;
            let newCurrentPoint = null;
            if (state.currentPoint) {
                let index = newContentPoint[action.payload.lang].findIndex(statePoint => {
                    return statePoint.id === state.currentPoint.id;
                });
                newCurrentPoint = newContentPoint[action.payload.lang][index];
            }
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContentPoint,
                currentPoint: newCurrentPoint
            };
        case POINT_DOWNLOADED:
            let newIndex;
            let id = action.payload.point.id;
            let point = state.content[action.payload.lang].find(function (point) {
                return point.id === id
            });
            let newContent = {...state.content};
            if (point) {
                let index = state.content[action.payload.lang].findIndex(statePoint => {
                    return statePoint.id === point.id
                });
                newContent[action.payload.lang][index] = action.payload.point;
                newIndex = index;
            } else {
                newContent[action.payload.lang] = [
                    ...state.content[action.payload.lang],
                    action.payload.point
                ];
                newIndex = newContent[action.payload.lang].length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentPoint: action.payload.point,
                currentIndex: newIndex
            };
        case POINT_FAILED:
            return {
                ...state,
                deletingMedia: false,
                pending: false,
                sending: false,
                error: action.payload,
                currentPoint: null,
                currentIndex: 0
            };
        case POINT_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content[action.payload.lang].findIndex(point => {
                    return point.id === action.payload.point.id
                }),
                currentPoint: action.payload.point
            };
        case POINTS_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload
            };
        case POINT_MEDIA_FOCUS:
            return {
                ...state,
                error: null,
                pending: false,
                currentMedia: action.payload
            };
        case POINT_MEDIA_UPLOADING:
            return {
                ...state,
                pendingMedias: [
                    ...state.pendingMedias,
                    action.payload
                ],
                sending: true
            };
        case POINT_MEDIA_UPLOADED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                uploadedMedias: [
                    ...state.uploadedMedias,
                    action.payload
                ],
                sending: false,
                currentMedia: action.payload
            };
        case POINT_MEDIA_FAILED:
            return {
                ...state,
                pendingMedias: state.pendingMedias.filter((media) => {
                    return media !== action.payload
                }),
                failedMedias: [
                    ...state.failedMedias,
                    action.payload
                ],
                currentMedia: action.payload
            };
        case POINT_MEDIA_DELETING:
            return {
                ...state,
                deletingMedia: true
            };
        case POINT_MEDIA_DELETED:
            const pointMediaDeleted = {...state.currentPoint};
            pointMediaDeleted.medias = pointMediaDeleted.medias.filter((media) => media.id !== action.payload);

            return {
                ...state,
                deletingMedia: false,
                currentPoint: pointMediaDeleted,
                currentMedia: null
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/points/reducers.js